import { Order } from '@/models'
import { get, orderBy } from 'lodash'
import OrderCard from './OrderCard'

export default {
  mixins: [
    Order.mixin()
  ],
  components: {
    OrderCard
  },
  data () {
    return {
      loading: false,
      type: null, // Can be OPEN, PREVIOUS, or RETURN 
      lastPage: 0
    }
  },
  computed: {
    page () {
      const page = (this.$route.query.page || 1) * 1
      if (isNaN(page)) {
        return 1
      }
      return page
    },
    orderRecordsSorted () {
      return orderBy(this.orderRecords, ['date'], ['desc'])
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    page () {
      this.loadData()
    }
  },
  methods: {
    changePage (page) {
      this.$router.push({
        query: {
          ...(this.$route.query || {}),
          page
        }
      })
    },
    async loadData () {
      this.loading = true
      try {
        const result = await this.orderFetchMany({
          params: {
            type: this.type,
            page: this.page
          }
        })
        this.lastPage = get(result.response, 'data.last_page')
        this.loading = false
      } catch (e) {
        this.loading = false
        throw e
      }
    }
  }
}